export enum ConfigRouteEnum {
    HOME = '',
    TRANSLATIONS = 'translations',
    QUERY = 'query',
    JSONATA = 'jsonata',
    AUTH = 'auth',
    NOT_ALLOWED = 'not-allowed',
    APP_SETTINGS = 'app-settings'
}
